import Logo from './';
import styles from './headerTile.style';

const HeaderTile = ({ classes, type, customTile, customLogo }) => (
  <div className={`${classes.headerTile} ${customTile}`}>
    <Logo className={`${classes.headerLogo} ${customLogo}`} type={type} />
  </div>
);

export default withStyles(styles)(HeaderTile);
